<template>
  <div id="indexNews">
    <el-col :sapn="24" style="padding: 0px">
      <div class="titleTop" style="position: relative">
        <h5 style="margin: 0">Main news</h5>
        <a @click="getList()" class="more"
          >More<span class="el-icon-more"></span
        ></a>
      </div>
    </el-col>
    <el-col :sapn="24" style="padding: 0px">
      <vueSeamless
        :data="newsList"
        :class-option="classOption"
        class="seamless-warp"
        style="height: 300px"
      >
        <ul class="item">
          <li v-for="item in newsList" :key="item.id" class="newli">
            <a @click="getId(item.id)">
              <span class="date" v-text="item.date"></span>
              <span class="title">{{ item.title }}</span>
            </a>
          </li>
        </ul>
      </vueSeamless>
    </el-col>
  </div>
</template>
<script>
import vueSeamless from 'vue-seamless-scroll'

export default {
  props: {
    newsList: {
      type: Array,
      default: function () {
        return [
          {
            id: 0,
            title: '',
            date: ''
          }
        ]
      }
    }
  },
  data() {
    return {
      newsInterval: 0
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.8, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  components: {
    vueSeamless
  },
  mounted() {
    // this.newsInterval = setInterval(this.align, 1000)
  },
  methods: {
    getId(index) {
      const { href } = this.$router.resolve({
        path: '/newsDetails',
        query: { Star: index }
      })

      window.open(href, '_blank')
    },
    getList() {
      const { href } = this.$router.resolve({
        path: '/newsList'
      })

      window.open(href, '_blank')
    }
  }
}
</script>
<style  scoped>
.seamless-warp {
  overflow: hidden;
  border: 1px solid #e0dddd;
}
.seamless-warp li {
  height: 70px;
  border-bottom: 1px solid #e0dddd;
  line-height: 69px;
  padding: 0 15px 0 15px;
}
ul {
  padding: 0 !important;
  margin: 0 !important;
}
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 300px;
  display: block;
  float: left;
}
.date {
  float: left;
  margin-right: 25px;
}
.more {
  background: #193c5a;
  border-radius: 3px;
  font-weight: 100;
  font-size: 15px;
  line-height: 23px;
  color: #ffffff !important;
  height: 23px;
  width: 70px;
  text-align: center;
  position: absolute;
  right: 15px;
}
.newli {
  list-style-type: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomNews.vue